export const CONVERTER_IDENTIFIER = /^[A-Z-ĄĆĘŁŃÓŚŹŻ\d .,\-+:'/()&$*]+$/;
export const SAMPLE_NAME = /^[A-Z-ĄĆĘŁŃÓŚŹŻ0-9 -]+$/;
export const NUMBER_INTEGER = /^-?\d+$/;
export const NUMBER_DECIMAL = /^-?\d+(\.\d+)?$/;
export const NUMBER_3_DIGITS_PRECISION = /^-?\d+(\.\d{1,3})?$/;
export const NUMBER_2_DIGITS_PRECISION = /^-?\d+(\.\d{1,2})?$/;
